import { ref, reactive } from 'vue';
import router from '@/router/index'


import { packClub, packClubResponse, packClubRequest } from '@/interfaces/packClub';
import { Club, ClubResponse, ClubRequest, SingleClubResponse } from '@/interfaces/club';




import { Permission, PermissionResponse, PermissionRequest, AffectedPermissionRequest, AffectedPermissionResponse } from '@/interfaces/permission';
import { User, UserResponse, SingleUserResponse, UserRequest } from '@/interfaces/user';




export const clubs = reactive<ClubResponse>({
    data: []
});


export const singleClub = reactive<SingleClubResponse>({
    data: null
});

export const packsClub = reactive<packClubResponse>({
    data: []
});





export const genders = ref<any[]>([]);
export const bank_names = ref<any[]>([]);
export const payment_methods = ref<any[]>([]);
export const paginationLinks = ref<any>({});

const getItemClub = localStorage.getItem('selectedClub') ?? null;
const parseClub = getItemClub ? JSON.parse(getItemClub) : null
export const clubUUID = ref(parseClub?.uuid || null);
export const currentClub = ref<Club>(parseClub || {});

const strorageUserUUID = localStorage.getItem('selectedUserUUID') ?? '';
export const userUUID = ref(strorageUserUUID || null);
export const loggedIn = ref(strorageUserUUID ? true : false)
const getUser = localStorage.getItem('user') ?? null;
const parseUser = getUser ? JSON.parse(getUser) : null
//export const user = ref(parseUser?.data || null);
export const user = ref<User>(parseUser?.data || {});



const getLang = localStorage.getItem('selectedLang') ?? 'fr'

export const selectedLang = ref(getLang);




// permissions
export const permissions = reactive<PermissionResponse>({
    data: []
});
// permissions
export const userPermissions = reactive<AffectedPermissionResponse>({
    data: []
});


/**
 * Users
 */
// permissions
export const users = reactive<UserResponse>({
    data: []
});

export const singleUser = reactive<SingleUserResponse>({
    data: null
});
